import Global from "./global";

class Header{
    constructor() {
        this.global = new Global();
        this.header = document.querySelector(".header");
        this.hamburger = this.header.querySelector('.header__hamburger');
        this.nav = this.header.querySelector('nav');

        !this.hamburger || this.hamburger.addEventListener('click', e => this.menuToggle(e));
        window.addEventListener('resize', () => this.onResize());
    }
    menuToggle(e){
        e.target.classList.toggle('active');
        this.global.slideToggle(this.nav);
    }
    onResize(){
        if(window.innerWidth > 991){
            this.nav.removeAttribute('style');
            this.hamburger.classList.remove('active');
        }
    }
}

export default  Header;